import axios from "axios";
import { API_BASE_WS_URL } from "../../../util/constants";

export function requestAddIdentity(params: any) {
  const formData = new FormData();
  if (params?.file) {
    formData.append("file", params.file);
  }
  return axios.request({
    method: "post",
    withCredentials: true,
    url: API_BASE_WS_URL + "/add-identity",
    headers: {
      "content-type": "application/json",
    },
    data: formData,
    params: {
      group: params?.group ? params.group : null,
      type: params?.type ? params.type : null,
      storePwd: params?.storePwd ? params.storePwd : null,
      keyPwd: params?.keyPwd ? params.keyPwd : null,
    },
  });
}

export function requestWSClients() {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: API_BASE_WS_URL + "/ws-clients",
  });
}

export function requestSaveWSClient(params: any) {
  const jsonRequest = JSON.stringify(params);
  return axios.request({
    method: "post",
    url: API_BASE_WS_URL + "/save-ws-client",
    headers: {
      "content-type": "application/json",
    },
    data: jsonRequest,
  });
}

export function requestDeleteWSClient(para: any) {
  return axios.request({
    method: "delete",
    withCredentials: true,
    url: `${API_BASE_WS_URL}/delete-ws-client/${para.id}`,
  });
}
